export function SchedulingSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/scheduling.svg'"></ng-include>`
    }
}
            